var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerMilitary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 42.2422C18.6644 42.2422 18.3315 42.1118 18.0738 41.8538L6.97315 30.6218C0.342282 23.9125 0.342282 12.9929 6.97315 6.28366C10.1866 3.03224 14.4577 1.24219 19 1.24219C23.5423 1.24219 27.8134 3.03224 31.0268 6.28366C37.6577 12.9929 37.6577 23.9098 31.0268 30.6218L19.9262 41.8538C19.6711 42.1118 19.3356 42.2422 19 42.2422Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 42.2422C18.6644 42.2422 18.3315 42.1118 18.0738 41.8538L6.97315 30.6218C0.342282 23.9125 0.342282 12.9929 6.97315 6.28366C10.1866 3.03224 14.4577 1.24219 19 1.24219C23.5423 1.24219 27.8134 3.03224 31.0268 6.28366C37.6577 12.9929 37.6577 23.9098 31.0268 30.6218L19.9262 41.8538C19.6711 42.1118 19.3356 42.2422 19 42.2422Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 6.74219,
    r: 6,
    fill: "#06799B",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8554",
    x: 0.5,
    y: 0.742188,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8554",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerMilitary);
export default __webpack_public_path__ + "static/media/marker_military.3ce52752916d5a2299537c9c120f0198.svg";
export { ForwardRef as ReactComponent };